<template>
    <div class="basket-list basket-col">
        <div class="basket-list-header">
            <div class="discounts" v-if="isProcessingDiscount">
              <div class="discount">{{phrases.BASKET_CALCULATE_DISCOUNTS}}</div>
            </div>
            <div class="discounts" v-if="discounts.length">
                <div class="discount" v-for="(discount, index) in discounts" :key="index">
                    <div class="discount-title">{{phrases.TEXT_ORDER_IN_PROMOTION}} «{{ discount.title }}».</div>
                    <div class="discount-description"><span v-if="discount.sum > 0">{{phrases.TEXT_YOU_HAVE_DISCOUNT}} {{ discount.sum }}&#8381;.</span> {{phrases.TEXT_GREAT}}</div>
                    <div class="discount-note" v-if="discount.note">{{discount.note}}</div>
                    <!--div class="discount-close"><span class="pp-icon pp-icon-close"></span></div-->
                </div>
            </div>
            <div class="basket-sauces">
                <div class="basket-sauces-title">{{phrases.PRODUCT_CHOOSE_DIP}}</div>
                <div class="basket-sauces-title" v-if="total.free_sauces_count > 0">{{ getFreeSaucePhrase() }}</div>
                <div class="basket-sauces-list">
                    <div class="button-sauce" :class="{'blocked': !sauce.available}"
                         v-for="sauce in sauces" :key="sauce.id" @click="addSauceToBasket(sauce)">{{ sauce.title }}</div>
                </div>
                <div class="basket-attributes">
                  <div class="basket-sauces-title">{{phrases.ADD_FREE_ATTRIBUTE}}</div>
                  <div class="basket-sauces-list">
                    <div class="button-sauce" :class="{'blocked':  isBlocked(attribute)}"
                         v-for="attribute in attributes" :key="attribute.id"
                         @click="addAttributeToBasket(attribute)">{{ attribute.title }}</div>
                  </div>
                </div>
            </div>
        </div>
        <div class="basket-list-body" id="basket-list-body">
            <BasketComboItem
                v-for="comboItem in updateBasket(filterCombo(productItems))"
                :combo="comboItem"
                :key="comboItem.code"
            ></BasketComboItem>

            <BasketItem v-for="(item, index) in updateBasket(filterProducts(productItems))"
                        :is_delivery="isDelivery" :key="item.id" :quantity="item.quantity" :item="item" :index="index"></BasketItem>

            <BasketItem v-for="(freeProduct, index) in freeProducts"
                  :is_delivery="isDelivery"
                  :key="'free_product' + index" :quantity="1" :item="Object.assign(freeProduct, {isShareItem: true})">
            </BasketItem>
        </div>
        <BasketListFooter></BasketListFooter>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Utils from "../Utils";
    import BasketItem from "./BasketItem";
    import BasketUtils from "./BasketUtils";
    import BasketListFooter from "./BasketListFooter";
    import BasketComboItem from "@/components/basket/combo/BasketComboItem.vue";

    export default {
        name: "List",
        data: function () {
          return {};
        },
        watch:{
            productItems: {
                handler: function() {
                    this.calculateDiscount();
                },
                deep: true
            },
        },
        methods:{
            addAttributeToBasket(attribute){
              if(this.isBlocked(attribute)){
                return false;
              }
              this.addSauceToBasket(Object.assign({'product_id': attribute['id']}, attribute));
            },
            addSauceToBasket(sauce){
                if(!sauce.available){
                  return false;
                }
                const groupProducts = this.products[sauce['group_id']];
                const product = groupProducts.find(p => { return p['id'] === sauce['product_id']; });
                if(product === undefined){
                  console.error("No fount product for ", product);
                  return;
                }
                this.$store.dispatch({
                    type: 'order/addToBasket',
                    offer: this.prepareBasketOffer(product, sauce),
                });
            },
            isBlocked: function (item){
              let max_qnt_in_basket = false;
              if(item.max_quantity_for_an_order !== null &&
                  this.productItems.find(el => el.id === item.id)){
                const basketItem = this.productItems.filter(el => el.id === item.id);
                max_qnt_in_basket = basketItem.quantity === basketItem.max_quantity_for_an_order;
              }
              return !item.available || max_qnt_in_basket;
            },
            getFreeSaucePhrase: function (){
              const component = this;
              return (component.total.free_sauces_count + ' ' + component.morph(component.total.free_sauces_count, component.phrases.SAUCE, component.phrases.SAUCE_2, component.phrases.SAUCES) + ' ' + this.phrases.FREE_OF_CHARGE).toLowerCase();
            },
            updateBasket: function (basket){
              const stop_list = this.stopList;
              const updated_basket = [];
              for (const item of basket){
                const basketItem = Object.assign({}, item, {available: (!stop_list.find(code => code === item.code))});
                updated_basket.push(basketItem);
              }
              return updated_basket;
            },
            filterProducts: function (items){
              return items.filter(i => { return i.entity === undefined || i.entity === 'Product'; });
            },
            filterCombo: function (items){
              return items.filter(i => { return i.entity !== undefined && i.entity === 'combo'; });
            }
        },
        computed: {
            ...mapGetters('order', {
                total: 'total',
                isDelivery: 'isDelivery',
                isDeferOrder: 'isDeferOrder',
                isCheckout: 'getIsCheckout',
                isConfirmOrder: 'getIsConfirmOrder',
                order: 'getOrderInfo',
                discounts: 'getDiscounts',
                discountSum: 'getDiscountSum',
                freeProducts: 'getFreeProducts',
            }),
            ...mapGetters('app', {
                phrases: 'getPhrases',
                isSizeMd: 'getIsSizeMd',
                isProcessingDiscount: 'getProcessDiscount',
            }),
            ...mapGetters('catalog', {
                sauces: 'getSauces',
                attributes: 'getAttributes',
                products: 'getProducts'
            })
        },
        components: {
            BasketComboItem,
            BasketItem,
            BasketListFooter
        },
        mixins: [Utils, BasketUtils],
    }
</script>

<style lang="scss">
  .button{
    &-sauce{
      &.blocked{
        cursor: default;
        background: #e56621;
        color: #ffffff;
        opacity: 0.7;
        &:hover{
          background: #e56621;
          color: #fff;
        }
      }
    }
  }
</style>
